import {
  AccessControlObject,
  AccessControlObjectCard,
  AccessControlObjectSummary,
  AccessControlGroupsWidget,
  AccessControlIdpWidget,
  AccessControlObjectsWithImpactedAccess,
  AccessControlUserDatasource,
  AccessControlUserDetailsOverview,
  AccessControlUserEntities,
  AccessControlUserGroupByDepartmentItem,
  AccessControlUserListItem,
  AccessControlUsersSummary,
  AccessControlUsersWidget,
  DataSensitivityLevels,
  IGetAccessControlUsersFilterParams,
  ObjectsImpactedAccessTypeFilter,
  AccessControlEntityWidget,
  AccessControlUserEntityCard,
  AccessControlGlobalObjectCard,
  AccessControlEntityAccessWidget,
  AccessControlObjectsWithImpactedAccessByDept,
  AccessControlUserAttributesWidget,
  AccessControlUserAttributeCard,
  AccessControlAccessibleWidget,
  AccessControlFilters,
  AccessControlObjectCardBySensitivity,
  AccessControlGroupDetailsOverview,
  IGetAccessControlGroupsFilterParams,
  IdentityProviderParams,
  DirectoryService,
  AlertsOverviewWidget,
  TestConnectionParams,
  AccessControlGroupCard,
  Access360WidgetIndexData,
  ActivityLogItem,
  RecentAccessItem,
  StaleFilesWidget,
  AccessControlObjectsCount,
  AccessibleAttributesWidget,
  UserDatasourcesWidget,
  SalesforceMonitoredUsersWidgetData,
  SalesforceObjectsWidgetData,
  SalesforceUnresolvedAlertsWidgetData,
  SalesforceUserAccessWidgetData,
  SalesforceUserCountsWidgetData,
  SalesforceUserDetailsWidgetData,
  SalesforceDashboardParams
} from './types'
import {
  mapQueryAccessControlObjectsList,
  mapQueryAccessControlObjectsSummary,
  mapQueryGroupsWidget,
  mapQueryIdpWidget,
  mapQueryObjectsWithImpactedAccess,
  mapQueryUserCardsGroupedByDepartments,
  mapQueryUserDatasources,
  mapQueryUserEntities,
  mapQueryUserOverview,
  mapQueryUsers,
  mapQueryUsersForEntities,
  mapQueryUsersSummary,
  queryAccessControlObjectsList,
  queryAccessControlObjectsSummary,
  mapQueryUsersWidget,
  queryGroupsWidget,
  queryIdpWidget,
  queryObjectsWithImpactedAccess,
  queryUserCardsGroupedByDepartments,
  queryUserDatasources,
  queryUserEntities,
  queryUserOverview,
  queryUsers,
  queryUsersSummary,
  queryUsersWidget,
  queryAccessControlObjectsCards,
  mapQueryAccessControlObjectsCards,
  queryEntitiesWithAccess,
  mapQueryUserEntitiesWithAccess,
  mapQueryAccessControlGlobalObjectsSummary,
  queryAccessControlGlobalObjectsSummary,
  mapQueryAccessControlGlobalObjectsCards,
  queryAccessControlGlobalObjectsCards,
  queryAccessControlEntitiesGroupByType,
  mapAccessControlEntitiesGroupByType,
  queryUserEntitiesGroupByDatasource,
  mapAccessControlEntitiesGroupByDatasource,
  queryAccess360Widget,
  mapQueryAccess360Widget,
  queryEntityTypesWithAccess,
  mapQueryEntityTypesWithAccess,
  queryObjectsWithImpactedAccessByDept,
  mapQueryObjectsWithImpactedAccessByDept,
  queryAccessControlUserAttributesSummary,
  mapQueryAccessControlUserAttributesSummary,
  queryAccessControlUserAttributeCards,
  mapQueryAccessControlUserAttributeCards,
  queryAccessibleWidget,
  mapQueryAccessibleWidget,
  queryAccessControlFilters,
  mapQueryAccessControlFilters,
  queryAccessControlObjectsCardBySensitivity,
  mapQueryAccessControlObjectsCardsBySensitivity,
  queryAccessControlCounts,
  mapQueryAccessControlCounts,
  queryAccessControlObjectDetails,
  mapQueryAccessControlObjectDetails,
  queryGroups,
  mapQueryGroups,
  queryAccessControlIdpDatasources,
  mapQueryAccessControlIdpDatasources,
  mutationCreateIdentityProvider,
  queryAccessControlIdpList,
  mapQueryAccessControlIdpList,
  queryAccessControlIdpById,
  mapQueryAccessControlIdpById,
  queryAccessControlIdpsByIds,
  mapQueryAccessControlIdpsByIds,
  mutationUpdateIdentityProvider,
  mapQueryGroupsForEntities,
  queryGroupOverview,
  mapQueryGroupOverview,
  queryUsersByGroup,
  mapQueryUsersByGroup,
  mapQuerySubGroups,
  querySubGroups,
  queryGroupsByUser,
  mapQueryGroupsByUser,
  queryAlertsOverviewWidget,
  mapQueryAlertsOverviewWidget,
  mutationTestConnection,
  mapQueryUsersForObjects,
  queryAccessControlTotalObjectPerUserOrGroup,
  mapQueryAccessControlObjectsTotalObjects,
  queryAccessControlObjectsAccessViaGroup,
  mapQueryAccessControlObjectsAccessViaGroup,
  queryEntitiesViaGroup,
  mapQueryAccessControlEntitiesViaGroup,
  queryAttributesViaGroup,
  mapQueryAttributesViaGroup,
  queryAccessControlObjectsCountForList,
  mapQueryActivityLogsList,
  queryActivityLogsList,
  queryActivityLogsCount,
  mapQueryActivityLogsCount,
  queryRecentAccessList,
  queryRecentAccessCount,
  mapQueryRecentAccessList,
  mapQueryRecentAccessCount,
  queryStaleFilesWidget,
  mapQueryStaleFilesWidget,
  mapQueryRecentAccessByObjectId,
  queryStaleFilesList,
  mapQueryStaleFilesList,
  queryStaleFilesCount,
  mapQueryStaleFilesCount,
  queryStaleFilesAlertId,
  mapQueryStaleFilesAlertId,
  queryOpenAccessSummaryWidget,
  mapQueryOpenAccessSummaryWidget,
  queryAccessControlActivityLog,
  mapQueryAccessControlActivityLog,
  queryUserActivityWidget,
  mapQueryUserActivityWidget,
  queryAccessControlActivityLogUsers,
  mapQueryAccessControlActivityLogUsers,
  queryDeletedFiles,
  mapQueryDeletedFiles,
  queryAccessControlAllObjectsCount,
  mapQueryAccessControlAllObjectsCount,
  mapQueryAccessAttributesWidget,
  queryAccessibleAttributesWidget,
  IGetAccessibleAttributesWidgetParams,
  queryUsersDatasourcesWidget,
  mapQueryUsersDatasourcesWidget,
  queryAllUsers,
  mapQueryAllUsers,
  querySalesforceMonitoredUsersWidget,
  mapQuerySalesforceMonitoredUsersWidget,
  querySalesforceObjectsWidget,
  mapQuerySalesforceObjectsWidget,
  querySalesforceUnresolvedAlertsWidget,
  mapQuerySalesforceUnresolvedAlertsWidget,
  querySalesforceUserAccessWidget,
  mapQuerySalesforceUserAccessWidget,
  querySalesforceUserCountsWidget,
  mapQuerySalesforceUserCountsWidget,
  querySalesforceUserDetailsWidget,
  mapQuerySalesforceUserDetailsWidget,
  queryAccessControlDepartments,
  mapQueryAccessControlDepartments,
  mapQueryRecentAccessByObjectIdForNonScannedFiles
} from './queries'
import { AccessControlOpenAccessSummaryWidget } from './pages/folders/types'
import graphqlService from '../../services/graphqlService'
import { PageInfo } from '../../services/graphqlSchemaTypes'
import { PAGE } from '../../constants'
import { DataSource } from '../../services/api/apiTypes'
import { DownloadListParams } from '../../interfaces'
import apiService from '../../services/api/apiService'
import { UNIQUE_WIDGET_INDEX } from '../dashboards/mainDashboardv2/constants'
import {
  FetchClassificationsListParams,
  FileListResponseType
} from '../classifications/classificationsSlice'
import { IGetAttributesParams, IGetAttributesTableListParams } from '../attributes/attributesSlice'

import { CompanyWideActivityWidgetParams } from '../dashboards/mainDashboardv2/slice'
import { IdentityActiveSummary } from '../dashboards/mainDashboardv2/queries'
import { Sensitivity } from '../dataSourcesMixed/dashboard/widget/SalesforceObjectsWidget'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

export const ACTION_FETCH_USERS_CARDS_BY_DEPT = 'accessControl/users/cardsByDept'
export const fetchUsersCardsGroupedByDept = createAsyncThunk(
  ACTION_FETCH_USERS_CARDS_BY_DEPT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryUserCardsGroupedByDepartments(params as IGetAccessControlUsersFilterParams)
    )
    return mapQueryUserCardsGroupedByDepartments(resultRaw)
  }
)

export const ACTION_FETCH_USERS_CARDS_BY_DEPT_PAGINATED =
  'accessControl/users/cardsByDept/paginated'
export const fetchUsersCardsGroupedByDeptPaginated = createAsyncThunk(
  ACTION_FETCH_USERS_CARDS_BY_DEPT_PAGINATED,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryUserCardsGroupedByDepartments(params as IGetAccessControlUsersFilterParams)
    )
    return mapQueryUserCardsGroupedByDepartments(resultRaw)
  }
)

export const ACTION_FETCH_USERS_LIST = 'accessControl/users/list'
export const fetchUsersList = createAsyncThunk(
  ACTION_FETCH_USERS_LIST,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryUsers(params as IGetAccessControlUsersFilterParams)
    )

    return params.entityId
      ? mapQueryUsersForEntities(resultRaw)
      : params.objectIds?.length
      ? mapQueryUsersForObjects(resultRaw)
      : mapQueryUsers(resultRaw)
  }
)

export const ACTION_FETCH_USERS_BY_GROUP = 'accessControl/groups/users/list'
export const fetchUsersByGroup = createAsyncThunk(
  ACTION_FETCH_USERS_BY_GROUP,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryUsersByGroup(params as IGetAccessControlUsersFilterParams)
    )

    return mapQueryUsersByGroup(resultRaw)
  }
)

export const ACTION_FETCH_GROUPS_LIST = 'accessControl/groups/list'
export const fetchGroupsList = createAsyncThunk(
  ACTION_FETCH_GROUPS_LIST,
  async (params: IGetAccessControlGroupsFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryGroups(params as IGetAccessControlGroupsFilterParams)
    )

    return params.entityId ? mapQueryGroupsForEntities(resultRaw) : mapQueryGroups(resultRaw)
  }
)

export const ACTION_FETCH_GROUPS_BY_USER = 'accessControl/users/groups/list'
export const fetchGroupsByUser = createAsyncThunk(
  ACTION_FETCH_GROUPS_BY_USER,
  async (params: IGetAccessControlGroupsFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryGroupsByUser(params as IGetAccessControlGroupsFilterParams)
    )

    return mapQueryGroupsByUser(resultRaw)
  }
)

export const ACTION_FETCH_SUB_GROUPS = 'accessControl/subgroups'
export const fetchSubGroups = createAsyncThunk(
  ACTION_FETCH_SUB_GROUPS,
  async (params: IGetAccessControlGroupsFilterParams) => {
    const resultRaw = await graphqlService.execute(
      querySubGroups(params as IGetAccessControlGroupsFilterParams)
    )

    return mapQuerySubGroups(resultRaw)
  }
)

export const ACTION_FETCH_USERS_SUMMARY = 'accessControl/users/summary'
export const fetchUsersSummary = createAsyncThunk(
  ACTION_FETCH_USERS_SUMMARY,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryUsersSummary(params))
    return mapQueryUsersSummary(resultRaw)
  }
)

export const ACTION_FETCH_USER_OVERVIEW = 'accessControl/user/overview'
export const fetchUserOverview = createAsyncThunk(
  ACTION_FETCH_USER_OVERVIEW,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryUserOverview(params))
    return mapQueryUserOverview(resultRaw)
  }
)

export const ACTION_FETCH_GROUP_OVERVIEW = 'accessControl/group/overview'
export const fetchGroupOverview = createAsyncThunk(
  ACTION_FETCH_GROUP_OVERVIEW,
  async (params: IGetAccessControlGroupsFilterParams) => {
    const resultRaw = await graphqlService.execute(queryGroupOverview(params))
    return mapQueryGroupOverview(resultRaw)
  }
)

export const ACTION_FETCH_USER_DATASOURCES = 'accessControl/user/datasources'
export const fetchUserDatasources = createAsyncThunk(
  ACTION_FETCH_USER_DATASOURCES,
  async (actionParams: IGetAccessControlUsersFilterParams) => {
    const { forAttributes, ...params } = actionParams
    const hasSensitivity = params.sensitivityLevels && params.sensitivityLevels.length
    const resultRaw = await graphqlService.execute(queryUserDatasources(params))
    const dataSourcesResult = mapQueryUserDatasources(resultRaw)
    // fetch attributes count for each datasource
    if (!forAttributes) return dataSourcesResult
    let attributesByDataSource: Array<{ id: string; attributesCount: number }> = []
    if (dataSourcesResult.list.length && (params.id || params.groupId)) {
      attributesByDataSource = await Promise.all(
        dataSourcesResult.list.map(async (ds) => {
          const resultRaw = await graphqlService.execute(
            queryAccessControlUserAttributesSummary({
              userId: params.id,
              groupId: params.groupId,
              datasourceIds: ds.id ? [ds.id] : [],
              // sensitivity: params.sensitivityLevels,
              hasDirectAccess: params.isDirectMembership
            })
          )
          const attributes = mapQueryAccessControlUserAttributesSummary(resultRaw)
          const attributesCount =
            attributes?.reduce(
              (acc, card) => ({
                count:
                  acc.count +
                  (hasSensitivity
                    ? params.sensitivityLevels?.includes(card.attributeSensitivity)
                      ? card.count
                      : 0
                    : card.count)
              }),
              { count: 0 }
            ).count || 0

          return { id: ds.id, attributesCount }
        })
      )
    }

    const listWithAttributes = dataSourcesResult.list?.map((ds) => {
      const attributesCount =
        attributesByDataSource.find((attrDs) => attrDs.id === ds.id)?.attributesCount || 0
      const objectsCount = ds?.objectsCount || 0
      return { ...ds, attributesCount, objectsCount }
    })

    return {
      list: listWithAttributes,
      total: dataSourcesResult.total
    }
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_FILTERS = 'accessControl/filters'
export const fetchAccessControlFilters = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_FILTERS,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlFilters(params))
    return mapQueryAccessControlFilters(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_DEPARTMENTS = 'accessControl/departments'
export const fetchAccessControlDepartments = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_DEPARTMENTS,
  async () => {
    const resultRaw = await graphqlService.execute(queryAccessControlDepartments())
    return mapQueryAccessControlDepartments(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_IDP_DATASOURCES = 'accessControl/idp/datasources'
export const fetchAccessControlIdpDatasources = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_IDP_DATASOURCES,
  async () => {
    const resultRaw = await graphqlService.execute(queryAccessControlIdpDatasources())
    return mapQueryAccessControlIdpDatasources(resultRaw)
  }
)

export const ACTION_CREATE_IDENTITY_PROVIDER = 'accessControl/idp/create'
export const createIdentityProvider = createAsyncThunk(
  ACTION_CREATE_IDENTITY_PROVIDER,
  async (params: IdentityProviderParams) => {
    await graphqlService.execute(mutationCreateIdentityProvider(params))
    // return mapQueryCreateIdentityProvider(resultRaw)
  }
)

export const ACTION_GOVERNANCE_REPORT = 'accessControl/governanceReport'
export const fetchReport = createAsyncThunk(
  ACTION_GOVERNANCE_REPORT,
  async (params: DownloadListParams): Promise<{ data: string; fileName: string }> => {
    const { data, headers } = await apiService.downloadFile(params)
    const disposition = headers['content-disposition']
    let fileName = ''
    if (disposition && disposition.indexOf('attachment') !== -1) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
      const matches = filenameRegex.exec(disposition)
      if (matches != null && matches[1]) {
        fileName = matches[1].replace(/['"]/g, '')
      }
    }

    return { data, fileName }
  }
)

// User Attributes
export type AccessControlUserAttributesParams = {
  userId?: number
  groupId?: number
  datasourceIds?: string[]
  sensitivity?: DataSensitivityLevels[]
  attributeIds?: string[]
  [PAGE]?: number
  hasDirectAccess?: boolean
}
export const ACTION_FETCH_USER_ATTRIBUTES_SUMMARY = 'accessControl/user/attributes/summary'
export const fetchUserAttributesSummary = createAsyncThunk(
  ACTION_FETCH_USER_ATTRIBUTES_SUMMARY,
  async (params: AccessControlUserAttributesParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlUserAttributesSummary(params))
    return mapQueryAccessControlUserAttributesSummary(resultRaw)
  }
)
export const ACTION_FETCH_USER_ATTRIBUTES_CARDS = 'accessControl/user/attributes/cards'
export const fetchUserAttributeCards = createAsyncThunk(
  ACTION_FETCH_USER_ATTRIBUTES_CARDS,
  async (params: AccessControlUserAttributesParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlUserAttributeCards(params))
    return mapQueryAccessControlUserAttributeCards(resultRaw)
  }
)

// 360 access control: objects
export type AccessControlObjectsParams = {
  hasOpenAccess?: boolean
  hasExcessiveAccess?: boolean
  hasExternalAccess?: boolean
  hasDirectAccess?: boolean
  datasourceIds?: string[]
  datasourceType?: string
  sensitivity?: DataSensitivityLevels[]
  attributeIds?: string[]
  accessControlUserIds?: number[]
  accessControlGroupIds?: number[]
  isOwner?: boolean
  departmentName?: string
  [PAGE]?: number
  fetchCount?: boolean
  searchText?: string
}
export const ACTION_OBJECTS_SUMMARY = 'accessControl/objects/summary'
export const fetchObjectsSummary = createAsyncThunk(
  ACTION_OBJECTS_SUMMARY,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlObjectsSummary(params))
    return mapQueryAccessControlObjectsSummary(resultRaw)
  }
)

export const ACTION_OBJECTS_SUMMARY_FILTERED = 'accessControl/objects/summaryFiltered'
export const fetchObjectsCounts = createAsyncThunk(
  ACTION_OBJECTS_SUMMARY_FILTERED,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlCounts(params))
    return mapQueryAccessControlCounts(resultRaw)
  }
)

export const ACTION_OBJECTS_CARDS = 'accessControl/objects/cards'
export const fetchObjectsCards = createAsyncThunk(
  ACTION_OBJECTS_CARDS,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlObjectsCards(params))
    return mapQueryAccessControlObjectsCards(resultRaw)
  }
)

export const ACTION_OBJECTS_CARDS_BY_SENSITIVITY = 'accessControl/objects/cardsBySensitivity'
export const fetchObjectsCardsBySensitivity = createAsyncThunk(
  ACTION_OBJECTS_CARDS_BY_SENSITIVITY,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(
      queryAccessControlObjectsCardBySensitivity(params)
    )
    return mapQueryAccessControlObjectsCardsBySensitivity(resultRaw)
  }
)

export const ACTION_OBJECTS_TOTAL_OBJECTS_FOR_USER_OR_GROUP =
  'accessControl/objects/totalObjectsForUserOrGroup'
export const fetchTotalObjectsForUserOrGroup = createAsyncThunk(
  ACTION_OBJECTS_TOTAL_OBJECTS_FOR_USER_OR_GROUP,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(
      queryAccessControlTotalObjectPerUserOrGroup(params)
    )
    return mapQueryAccessControlObjectsTotalObjects(resultRaw)
  }
)

export const ACTION_OBJECTS_ACCESS_VIA_GROUP = 'accessControl/objects/accessViaGroup'
export const fetchObjectsAccessViaGroup = createAsyncThunk(
  ACTION_OBJECTS_ACCESS_VIA_GROUP,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlObjectsAccessViaGroup(params))
    return mapQueryAccessControlObjectsAccessViaGroup(resultRaw)
  }
)

export const ACTION_OBJECTS_LIST = 'accessControl/objects/list'
export const fetchObjectsList = createAsyncThunk(
  ACTION_OBJECTS_LIST,
  async (params: AccessControlObjectsParams) => {
    const { fetchCount } = params
    const resultRaw = await graphqlService.execute(queryAccessControlObjectsList(params))
    const result = mapQueryAccessControlObjectsList(resultRaw)
    let count = result?.list?.length
    if (fetchCount) {
      const rawCount = await graphqlService.execute(queryAccessControlObjectsCountForList(params))
      if (rawCount.accessControlObjects.count) {
        count = rawCount.accessControlObjects.count
      }
    }
    return {
      ...result,
      total: count
    }
  }
)
export const ACTION_OBJECT_DETAILS = 'accessControl/objectDetails'
export const fetchObjectsDetails = createAsyncThunk(
  ACTION_OBJECT_DETAILS,
  async (params: IGetAccessControlUsersFilterParams & { datasourceType?: string }) => {
    const resultRaw = await graphqlService.execute(queryAccessControlObjectDetails(params))
    return mapQueryAccessControlObjectDetails(resultRaw)
  }
)

export const ACTION_ACCESS_CONTROL_GLOBAL_OBJECTS_SUMMARY = 'accessControl/objects/global-summary'
export const fetchAccessControlGlobalObjectsSummary = createAsyncThunk(
  ACTION_ACCESS_CONTROL_GLOBAL_OBJECTS_SUMMARY,
  async () => {
    const resultRaw = await graphqlService.execute(queryAccessControlGlobalObjectsSummary())
    return mapQueryAccessControlGlobalObjectsSummary(resultRaw)
  }
)

export const ACTION_GLOBAL_OBJECTS_CARDS = 'accessControl/objects/global-cards'
export const fetchGlobalObjectsCards = createAsyncThunk(
  ACTION_GLOBAL_OBJECTS_CARDS,
  async (params: AccessControlObjectsParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlGlobalObjectsCards(params))
    return mapQueryAccessControlGlobalObjectsCards(resultRaw)
  }
)

// User entities
export const ACTION_FETCH_USER_ENTITIES = 'accessControl/user/entities'
export const fetchUserEntities = createAsyncThunk(
  ACTION_FETCH_USER_ENTITIES,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryUserEntities(params))
    return mapQueryUserEntities(resultRaw)
  }
)

export const ACTION_FETCH_USER_ENTITIES_CARD = 'accessControl/user/entitiesCard'
export const fetchUserEntityCards = createAsyncThunk(
  ACTION_FETCH_USER_ENTITIES_CARD,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlEntitiesGroupByType(params))
    const entityCards = mapAccessControlEntitiesGroupByType(resultRaw)
    const groupByDatasources = entityCards.length
      ? await graphqlService.execute(queryUserEntitiesGroupByDatasource(entityCards, params))
      : []

    return mapAccessControlEntitiesGroupByDatasource(groupByDatasources, entityCards)
  }
)

export const ACTION_FETCH_USERS_WIDGET = 'accessControl/dashboard/usersWidget'
export const fetchUsersWidget = createAsyncThunk(
  ACTION_FETCH_USERS_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryUsersWidget(params))
    return mapQueryUsersWidget(resultRaw)
  }
)

export const ACTION_FETCH_GROUPS_WIDGET = 'accessControl/dashboard/groupsWidget'
export const fetchGroupsWidget = createAsyncThunk(
  ACTION_FETCH_GROUPS_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryGroupsWidget(params))
    return mapQueryGroupsWidget(resultRaw)
  }
)

export const ACTION_FETCH_IDP_WIDGET = 'accessControl/dashboard/idpWidget'
export const fetchIdpWidget = createAsyncThunk(ACTION_FETCH_IDP_WIDGET, async () => {
  const resultRaw = await graphqlService.execute(queryIdpWidget())
  return mapQueryIdpWidget(resultRaw)
})

export const ACTION_FETCH_ACCESS360_WIDGET = 'accessControl/dashboard/access360'
export const fetchAccess360Widget = createAsyncThunk(
  ACTION_FETCH_ACCESS360_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccess360Widget(params))
    return mapQueryAccess360Widget(resultRaw)
  }
)

export const ACTION_FETCH_ENTITY_TYPES_ACCESS_WIDGET =
  'accessControl/dashboard/entityTypesWithAccess'
export const fetchEntityTypesAccessWidget = createAsyncThunk(
  ACTION_FETCH_ENTITY_TYPES_ACCESS_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryEntityTypesWithAccess(params))
    return mapQueryEntityTypesWithAccess(resultRaw)
  }
)

export const ACTION_FETCH_OBJECTS_WITH_OPEN_ACCESS = 'accessControl/dashboard/objectsWithOpenAccess'
export const fetchObjectsWithOpenAccess = createAsyncThunk(
  ACTION_FETCH_OBJECTS_WITH_OPEN_ACCESS,
  async (sensitivityLevel: DataSensitivityLevels) => {
    const resultRaw = await graphqlService.execute(
      queryObjectsWithImpactedAccess(ObjectsImpactedAccessTypeFilter.OpenAccess, sensitivityLevel)
    )
    return mapQueryObjectsWithImpactedAccess(resultRaw)
  }
)

export const ACTION_FETCH_STALE_FILES_WIDGET = 'accessControl/dashboard/staleFilesWidget'
export const fetchStaleFilesWidget = createAsyncThunk(
  ACTION_FETCH_STALE_FILES_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryStaleFilesWidget(params))
    return mapQueryStaleFilesWidget(resultRaw)
  }
)

export const ACTION_FETCH_OBJECTS_WITH_EXCESSIVE_ACCESS =
  'accessControl/dashboard/objectsWithExcessiveAccess'
export const fetchObjectsWithExcessiveAccess = createAsyncThunk(
  ACTION_FETCH_OBJECTS_WITH_EXCESSIVE_ACCESS,
  async (sensitivityLevel: DataSensitivityLevels) => {
    const resultRaw = await graphqlService.execute(
      queryObjectsWithImpactedAccess(
        ObjectsImpactedAccessTypeFilter.ExcessiveAccess,
        sensitivityLevel
      )
    )
    return mapQueryObjectsWithImpactedAccess(resultRaw)
  }
)

export const ACTION_FETCH_OBJECTS_WITH_OPEN_ACCESS_BY_DEPT =
  'accessControl/dashboard/objectsWithOpenAccessByDept'
export const fetchObjectsWithOpenAccessByDept = createAsyncThunk(
  ACTION_FETCH_OBJECTS_WITH_OPEN_ACCESS_BY_DEPT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryObjectsWithImpactedAccessByDept(ObjectsImpactedAccessTypeFilter.OpenAccess, params)
    )
    return mapQueryObjectsWithImpactedAccessByDept(resultRaw)
  }
)

export const ACTION_FETCH_OBJECTS_WITH_EXCESSIVE_ACCESS_BY_DEPT =
  'accessControl/dashboard/objectsWithExcessiveAccessByDept'
export const fetchObjectsWithExcessiveAccessByDept = createAsyncThunk(
  ACTION_FETCH_OBJECTS_WITH_EXCESSIVE_ACCESS_BY_DEPT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryObjectsWithImpactedAccessByDept(ObjectsImpactedAccessTypeFilter.ExcessiveAccess, params)
    )
    return mapQueryObjectsWithImpactedAccessByDept(resultRaw)
  }
)

export const ACTION_FETCH_OBJECTS_WITH_EXTERNAL_ACCESS_BY_DEPT =
  'accessControl/dashboard/objectsWithExternalAccessByDept'
export const fetchObjectsWithExternalAccessByDept = createAsyncThunk(
  ACTION_FETCH_OBJECTS_WITH_EXTERNAL_ACCESS_BY_DEPT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(
      queryObjectsWithImpactedAccessByDept(ObjectsImpactedAccessTypeFilter.ExternalAccess, params)
    )
    return mapQueryObjectsWithImpactedAccessByDept(resultRaw)
  }
)

export const ACTION_FETCH_ENTITIES_WIDGET = 'accessControl/dashboard/entitiesWidget'
export const fetchEntitiesWidget = createAsyncThunk(ACTION_FETCH_ENTITIES_WIDGET, async () => {
  const resultRaw = await graphqlService.execute(queryEntitiesWithAccess())
  return mapQueryUserEntitiesWithAccess(resultRaw)
})

export const ACTION_FETCH_ACCESSIBLE_WIDGET = 'accessControl/dashboard/accessibleWidget'
export const fetchAccessibleWidget = createAsyncThunk(
  ACTION_FETCH_ACCESSIBLE_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccessibleWidget(params))
    return mapQueryAccessibleWidget(resultRaw)
  }
)

export const ACTION_FETCH_ALERTS_OVERVIEW_WIDGET = 'accessControl/dashboard/alertsOverviewWidget'
export const fetchAlertsOverviewWidget = createAsyncThunk(
  ACTION_FETCH_ALERTS_OVERVIEW_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAlertsOverviewWidget(params))
    return mapQueryAlertsOverviewWidget(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_IDP_LIST = 'accessControl/idp/list'
export const fetchAccessControlIdpList = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_IDP_LIST,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlIdpList(params))
    return mapQueryAccessControlIdpList(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_IDP_BY_ID = 'accessControl/idp/byId'
export const fetchAccessControlIdpById = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_IDP_BY_ID,
  async (id: string) => {
    const resultRaw = await graphqlService.execute(queryAccessControlIdpById(id))
    return mapQueryAccessControlIdpById(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_IDPS_BY_IDS = 'accessControl/idp/byIds'
export const fetchAccessControlIdpsByIds = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_IDPS_BY_IDS,
  async (ids: string[]) => {
    const resultRaw = await graphqlService.execute(queryAccessControlIdpsByIds(ids))
    return mapQueryAccessControlIdpsByIds(resultRaw)
  }
)

export const ACTION_UPDATE_IDENTITY_PROVIDER = 'accessControl/idp/update'
export const updateIdentityProvider = createAsyncThunk(
  ACTION_UPDATE_IDENTITY_PROVIDER,
  async (params: IdentityProviderParams) => {
    await graphqlService.execute(mutationUpdateIdentityProvider(params))
  }
)

export const ACTION_TEST_CONNECTION = 'accessControl/idp/testConnection'
export const testIdpConnection = createAsyncThunk(
  ACTION_TEST_CONNECTION,
  async (params: TestConnectionParams) => {
    const response = await graphqlService.execute(mutationTestConnection(params))
    const data =
      response.testConnectionActiveDirectoryIdp ||
      response.testConnectionGoogleWorkspaceIdp ||
      response.testConnectionAwsIamIdp

    return {
      success: data.success
    }
  }
)

export const ACTION_FETCH_ENTITIES_VIA_GROUP = 'accessControl/entities/viaGroup'
export const fetchEntitiesViaGroup = createAsyncThunk(
  ACTION_FETCH_ENTITIES_VIA_GROUP,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryEntitiesViaGroup(params))
    return mapQueryAccessControlEntitiesViaGroup(resultRaw)
  }
)

export const ACTION_FETCH_ATTRIBUTES_VIA_GROUP = 'accessControl/attributes/viaGroup'
export const fetchAttributesViaGroup = createAsyncThunk(
  ACTION_FETCH_ATTRIBUTES_VIA_GROUP,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAttributesViaGroup(params))
    return mapQueryAttributesViaGroup(resultRaw)
  }
)

export const ACTION_FETCH_ACTIVITY_LOGS = 'accessControl/activityLogs'
export const fetchActivityLogs = createAsyncThunk(
  ACTION_FETCH_ACTIVITY_LOGS,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryActivityLogsList(params))
    const list = mapQueryActivityLogsList(resultRaw)
    return {
      list
    }
  }
)

export const ACTION_FETCH_ACTIVITY_LOGS_COUNT = 'accessControl/activityLogsCount'
export const fetchActivityLogsCount = createAsyncThunk(
  ACTION_FETCH_ACTIVITY_LOGS_COUNT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryActivityLogsCount(params))
    const total = mapQueryActivityLogsCount(resultRaw)
    return {
      total
    }
  }
)

export const ACTION_FETCH_RECENT_ACCESS = 'accessControl/recentAccess'
export const fetchRecentAccess = createAsyncThunk(
  ACTION_FETCH_RECENT_ACCESS,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryRecentAccessList(params))
    const list = params?.objectIds
      ? params?.isScanned
        ? mapQueryRecentAccessByObjectId(resultRaw)
        : mapQueryRecentAccessByObjectIdForNonScannedFiles(resultRaw)
      : mapQueryRecentAccessList(resultRaw)
    return {
      list
    }
  }
)

export const ACTION_FETCH_RECENT_ACCESS_COUNT = 'accessControl/recentAccessCount'
export const fetchRecentAccessCount = createAsyncThunk(
  ACTION_FETCH_RECENT_ACCESS_COUNT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryRecentAccessCount(params))
    const total = mapQueryRecentAccessCount(resultRaw)
    return {
      total
    }
  }
)

export const ACTION_FETCH_STALE_FILES_ALERT_ID = 'accessControl/staleFilesAlertId'
export const fetchStaleFilesAlertId = createAsyncThunk(
  ACTION_FETCH_STALE_FILES_ALERT_ID,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryStaleFilesAlertId(params))
    return mapQueryStaleFilesAlertId(resultRaw)
  }
)

export const ACTION_STALE_FILES_LIST = 'accessControl/staleFilesList'
export const fetchStaleFilesList = createAsyncThunk(
  ACTION_STALE_FILES_LIST,
  async (params: FetchClassificationsListParams) => {
    const queryParams = { ...params }
    const resultRaw = await graphqlService.execute(queryStaleFilesList(queryParams))
    return mapQueryStaleFilesList(resultRaw)
  }
)
export const ACTION_STALE_FILES_COUNT = 'accessControl/staleFilesCount'
export const fetchStaleFilesCount = createAsyncThunk(
  ACTION_STALE_FILES_COUNT,
  async (params: IGetAttributesParams & IGetAttributesTableListParams) => {
    const resultRaw = await graphqlService.execute(queryStaleFilesCount(params))
    return mapQueryStaleFilesCount(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_ACTIVITY_LOG = 'accessControl/activityLog'
export const fetchAccessControlActivityLog = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_ACTIVITY_LOG,
  async (params: any) => {
    const raw = await graphqlService.execute(queryAccessControlActivityLog(params))
    return mapQueryAccessControlActivityLog(raw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_ACTIVITY_LOG_USERS = 'accessControl/activityLog/users'
export const fetchAccessControlActivityLogUsers = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_ACTIVITY_LOG_USERS,
  async (params: any) => {
    const raw = await graphqlService.execute(queryAccessControlActivityLogUsers(params))
    return mapQueryAccessControlActivityLogUsers(raw)
  }
)

// salesforce dashboard widget thunks

export const ACTION_FETCH_SF_MONITORED_USERS = 'accessControl/salesforce/monitoredUsers'
export const fetchSalesforceMonitoredUsers = createAsyncThunk(
  ACTION_FETCH_SF_MONITORED_USERS,
  async (params: SalesforceDashboardParams) => {
    const raw = await graphqlService.execute(querySalesforceMonitoredUsersWidget(params))
    return mapQuerySalesforceMonitoredUsersWidget(raw)
  }
)

export const ACTION_FETCH_SF_OBJECTS = 'accessControl/salesforce/objects'
export const fetchSalesforceObjects = createAsyncThunk(
  ACTION_FETCH_SF_OBJECTS,
  async (params: SalesforceDashboardParams & { sensitivity?: Sensitivity[] }) => {
    const raw = await graphqlService.execute(querySalesforceObjectsWidget(params))
    return mapQuerySalesforceObjectsWidget(raw)
  }
)

export const ACTION_FETCH_SF_UNRESOLVED_ALERTS = 'accessControl/salesforce/unresolvedAlerts'
export const fetchSalesforceUnresolvedAlerts = createAsyncThunk(
  ACTION_FETCH_SF_UNRESOLVED_ALERTS,
  async (params: SalesforceDashboardParams) => {
    const raw = await graphqlService.execute(querySalesforceUnresolvedAlertsWidget(params))
    return mapQuerySalesforceUnresolvedAlertsWidget(raw)
  }
)

export const ACTION_FETCH_SF_USER_ACCESS = 'accessControl/salesforce/userAccess'
export const fetchSalesforceUserAccess = createAsyncThunk(
  ACTION_FETCH_SF_USER_ACCESS,
  async (params: SalesforceDashboardParams) => {
    const raw = await graphqlService.execute(querySalesforceUserAccessWidget(params))
    return mapQuerySalesforceUserAccessWidget(raw)
  }
)

export const ACTION_FETCH_SF_USER_COUNTS = 'accessControl/salesforce/userCounts'
export const fetchSalesforceUserCounts = createAsyncThunk(
  ACTION_FETCH_SF_USER_COUNTS,
  async (params: SalesforceDashboardParams) => {
    const raw = await graphqlService.execute(querySalesforceUserCountsWidget(params))
    return mapQuerySalesforceUserCountsWidget(raw)
  }
)

export const ACTION_FETCH_SF_USER_DETAILS = 'accessControl/salesforce/userDetails'
export const fetchSalesforceUserDetails = createAsyncThunk(
  ACTION_FETCH_SF_USER_DETAILS,
  async (params: SalesforceDashboardParams) => {
    const raw = await graphqlService.execute(querySalesforceUserDetailsWidget(params))
    return mapQuerySalesforceUserDetailsWidget(raw)
  }
)

export enum ActivityEventType {
  read = 'READ_COUNT',
  write = 'WRITE_COUNT',
  delete = 'DELETE_COUNT',
  download = 'DOWNLOAD_COUNT',
  uniqueRead = 'UNIQUE_OBJECTS_READ',
  uniqueWrite = 'UNIQUE_OBJECTS_WRITE',
  create = 'CREATE_COUNT',
  // directoryDelete = 'DIRECTORY_DELETE_COUNT',
  all = 'TOTAL_EVENTS'
}

interface ActivityLogEvent {
  feature: ActivityEventType
  actualCount: number
}
export interface AccessControlActivityLog {
  start: string
  end: string
  userId: string
  userName: string
  totalEventCount: number
  uniqueFilesCount: number
  events: ActivityLogEvent[]
}

export interface AccessControlActivityLogUser {
  id: string
  name: string
}

export interface UserActivityWidgetParams extends CompanyWideActivityWidgetParams {
  identityIds: string[]
}
export const ACTION_FETCH_USER_ACTIVITY_WIDGET = 'fetch/userActivityWidget'
export const fetchUserActivityWidget = createAsyncThunk(
  ACTION_FETCH_USER_ACTIVITY_WIDGET,
  async (params: UserActivityWidgetParams) => {
    const result = await graphqlService.execute(queryUserActivityWidget(params))
    return mapQueryUserActivityWidget(result)
  }
)

export type FetchDeletedFilesParams = {
  datasourceId: string
  folderId: string
}
export const ACTION_FETCH_DELETED_FILES = 'fetch/deletedFiles'
export const fetchDeletedFiles = createAsyncThunk(
  ACTION_FETCH_DELETED_FILES,
  async (params: FetchDeletedFilesParams) => {
    const result = await graphqlService.execute(queryDeletedFiles(params))
    return mapQueryDeletedFiles(result)
  }
)

export interface DeletedFile {
  id: string
  name: string
  attributeCount: number
}

export const ACTION_FETCH_OPEN_ACCESS_SUMMARY_WIDGET =
  'accessControl/dashboard/openAccessSummaryWidget'
export const fetchOpenAccessSummaryWidget = createAsyncThunk(
  ACTION_FETCH_OPEN_ACCESS_SUMMARY_WIDGET,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryOpenAccessSummaryWidget(params))
    return mapQueryOpenAccessSummaryWidget(resultRaw)
  }
)

export const ACTION_FETCH_ACCESS_CONTROL_ALL_OBJECTS_COUNT = 'accessControl/allObjectsCount'
export const fetchAccessControlAllObjectsCount = createAsyncThunk(
  ACTION_FETCH_ACCESS_CONTROL_ALL_OBJECTS_COUNT,
  async (params: IGetAccessControlUsersFilterParams) => {
    const resultRaw = await graphqlService.execute(queryAccessControlAllObjectsCount(params))
    return mapQueryAccessControlAllObjectsCount(resultRaw)
  }
)

export const ACTION_FETCH_ACCESSIBLE_ATTRIBUTES_WIDGET = 'accessControl/accessibleAttributesWidget'
export const fetchAccessibleAttributesWidget = createAsyncThunk(
  ACTION_FETCH_ACCESSIBLE_ATTRIBUTES_WIDGET,
  async (params: IGetAccessibleAttributesWidgetParams) => {
    const resultRaw = await graphqlService.execute(queryAccessibleAttributesWidget(params))
    return mapQueryAccessAttributesWidget(resultRaw)
  }
)

export const ACTION_FETCH_USERS_DATASOURCES_WIDGET = 'accessControl/datasourcesWidget'
export const fetchUsersDatasourcesWidget = createAsyncThunk(
  ACTION_FETCH_USERS_DATASOURCES_WIDGET,
  async (params: IGetAccessibleAttributesWidgetParams) => {
    const resultRaw = await graphqlService.execute(queryUsersDatasourcesWidget(params))
    return mapQueryUsersDatasourcesWidget(resultRaw)
  }
)

export const ACTION_FETCH_ALL_ACCESS_CONTROL_USERS = 'accessControl/allUsers'
export const fetchAllAcesssControlUsers = createAsyncThunk(
  ACTION_FETCH_ALL_ACCESS_CONTROL_USERS,
  async () => {
    const resultRaw = await graphqlService.execute(queryAllUsers())
    return mapQueryAllUsers(resultRaw)
  }
)

interface AccessControlState {
  usersGroupByDepartments: {
    cards?: AccessControlUserGroupByDepartmentItem[]
    total?: number
  }
  users: {
    list?: AccessControlUserDetailsOverview[]
    total?: number
  }
  groups: {
    list?: AccessControlGroupDetailsOverview[]
    totalList?: number
    totalGroups?: number
    highSensitiveCount?: number
  }
  usersSummary: AccessControlUsersSummary
  userOverview: AccessControlUserDetailsOverview
  groupOverview: AccessControlGroupDetailsOverview
  usersCompact: {
    list?: AccessControlUserListItem[]
    total?: number
  }
  usersDatasources: {
    list?: AccessControlUserDatasource[]
    total?: number
  }
  groupsUsers: {
    list?: AccessControlUserListItem[]
    total?: number
    totalEmployeesCount?: number
    totalContractorsCount?: number
  }
  usersGroups: {
    list?: AccessControlGroupDetailsOverview[]
    total?: number
  }
  subGroups: {
    list?: AccessControlGroupDetailsOverview[]
    total?: number
  }
  objects: {
    list?: AccessControlObject[]
    listTotal?: number
    pageInfo?: PageInfo
    cards?: AccessControlObjectCard[]
    cardsTotal?: number
    globalCards?: AccessControlGlobalObjectCard[]
    globalCardsTotal?: number
    openAccess?: AccessControlObjectSummary
    excessiveAccess?: AccessControlObjectSummary
    cardsBySensitivity?: AccessControlObjectCardBySensitivity
    objectsFilteredCount?: number
    userOrGroupsTotalObjects?: number
    ownersFilteredCount?: number
    accessViaGroup?: {
      cards?: AccessControlGroupCard[]
      total?: number
    }
  }
  usersEntities: {
    list?: AccessControlUserEntities[]
    total?: number
    cards?: AccessControlUserEntityCard[]
    cardsTotal?: number
    entitiesAtRisk?: number
    entityTypes?: number
    accessViaGroup?: {
      cards?: AccessControlUserEntityCard[]
      cardsTotal?: number
      listTotal?: number
      list?: AccessControlUserEntities[]
    }
  }
  usersAttributes: {
    cards?: AccessControlUserAttributeCard[]
    cardsTotal?: number
    widgets?: AccessControlUserAttributesWidget[]
    accessViaGroup?: {
      cards?: AccessControlGroupCard[]
      cardsTotal?: number
      widgets?: AccessControlUserAttributesWidget[]
    }
  }

  userEntity: {
    summary?: {
      groupsCount: number
      usersCount: number
    }
  }
  activityLog: {
    list?: ActivityLogItem[]
    total?: number
  }
  recentAccess: {
    list?: RecentAccessItem[]
    total?: number
  }
  staleFiles: FileListResponseType
  staleFilesAlertId?: string
  identityProviders: {
    datasources?: DataSource[]
    list?: DirectoryService[]
    total?: number
    selectedIdp?: DirectoryService
    selectedIdps?: DirectoryService[]
    connectionVerified?: boolean
  }
  dashboardWidgets: {
    users?: AccessControlUsersWidget
    groups?: AccessControlGroupsWidget
    idp?: AccessControlIdpWidget
    objectsWithOpenAccess?: AccessControlObjectsWithImpactedAccess
    objectsWithOpenAccessByDept?: AccessControlObjectsWithImpactedAccessByDept
    objectsWithExcessiveAccess?: AccessControlObjectsWithImpactedAccess
    objectsWithExcessiveAccessByDept?: AccessControlObjectsWithImpactedAccessByDept
    objectsWithExternalAccessByDept?: AccessControlObjectsWithImpactedAccessByDept
    entitiesWithAccess?: AccessControlEntityWidget
    access360?: Access360WidgetIndexData
    entityTypesWithAccess?: AccessControlEntityAccessWidget
    accessible?: AccessControlAccessibleWidget
    alertsOverview?: AlertsOverviewWidget[]
    staleFilesWidget?: StaleFilesWidget
    openAccessSummaryWidget?: AccessControlOpenAccessSummaryWidget
  }
  filters: AccessControlFilters
  filesToExport?: { data: string; fileName: string }
  activityLogs?: AccessControlActivityLog[]
  activityLogUsers?: AccessControlActivityLogUser[]
  totalActivityLogs?: number
  userActivityWidgetData?: IdentityActiveSummary[]
  deletedFiles?: DeletedFile[]
  objectsCount?: AccessControlObjectsCount
  accessibleAttributesWidgetData?: AccessibleAttributesWidget[]
  usersDatasourcesWidgetData?: UserDatasourcesWidget[]
  allUsers?: { name: string; email: string }[]
  salesforceDashboard: {
    monitoredUsers?: SalesforceMonitoredUsersWidgetData
    objects?: SalesforceObjectsWidgetData
    unresolvedAlerts?: SalesforceUnresolvedAlertsWidgetData
    userAccess?: SalesforceUserAccessWidgetData
    userCounts?: SalesforceUserCountsWidgetData
    userDetails?: SalesforceUserDetailsWidgetData
  }
}
const initialState: AccessControlState = {
  usersGroupByDepartments: {},
  users: {},
  groups: {},
  usersSummary: {
    employeesCount: 0,
    contractorsCount: 0,
    totalContractorsCount: 0,
    totalEmployeesCount: 0
  },
  usersCompact: {},
  userOverview: {
    name: '',
    entitiesCount: 0,
    attributesCount: 0,
    groupsCount: 0
  },
  groupOverview: {
    id: '',
    name: '',
    usersCount: 0,
    attributesCount: 0,
    groupsCount: 0
  },
  groupsUsers: {},
  usersGroups: {},
  subGroups: {},
  usersDatasources: {},
  identityProviders: {},
  usersAttributes: {},
  usersEntities: {},
  userEntity: {},
  activityLog: {},
  recentAccess: {},
  staleFiles: {},
  objects: {},
  dashboardWidgets: {},
  filters: {},
  userActivityWidgetData: [],
  allUsers: [],
  salesforceDashboard: {}
}

const accessControlSlice = createSlice({
  name: 'accessControl',
  initialState,
  reducers: {
    resetUsersCardsGroupedByDept: (state) => {
      state.usersGroupByDepartments = initialState.usersGroupByDepartments
    },
    resetSelectedIdp: (state) => {
      state.identityProviders.selectedIdp = initialState.identityProviders.selectedIdp
    },
    resetEntities: (state) => {
      state.usersEntities = initialState.usersEntities
    },
    resetAttributes: (state) => {
      state.usersAttributes = initialState.usersAttributes
    },
    resetAlertsOverview: (state) => {
      state.dashboardWidgets.alertsOverview = initialState.dashboardWidgets.alertsOverview
    },
    resetFilesToExport: (state) => {
      state.filesToExport = initialState.filesToExport
    },
    resetTestConnection: (state) => {
      state.identityProviders.connectionVerified = initialState.identityProviders.connectionVerified
    },
    resetStaleFilesWidget: (state) => {
      state.dashboardWidgets.staleFilesWidget = initialState.dashboardWidgets.staleFilesWidget
    },
    resetStaleFilesAlertId: (state) => {
      state.staleFilesAlertId = initialState.staleFilesAlertId
    },
    resetUserActivityWidget: (state) => {
      state.userActivityWidgetData = initialState.userActivityWidgetData
    },
    resetAllObjectsCount: (state) => {
      state.objectsCount = undefined
    },
    resetOpenAccessSummaryWidget: (state) => {
      state.dashboardWidgets.openAccessSummaryWidget =
        initialState.dashboardWidgets.openAccessSummaryWidget
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUsersCardsGroupedByDept.fulfilled, (state, { payload }) => {
      state.usersGroupByDepartments.cards = payload.cards
      state.usersGroupByDepartments.total = payload.total
    })
    builder.addCase(fetchUsersCardsGroupedByDept.rejected, (state) => {
      state.usersGroupByDepartments.cards = []
      state.usersGroupByDepartments.total = 0
    })
    builder.addCase(fetchUsersCardsGroupedByDeptPaginated.fulfilled, (state, { payload }) => {
      // Append new cards to existing ones for pagination
      const existingCards = state.usersGroupByDepartments.cards || []
      state.usersGroupByDepartments.cards = [...existingCards, ...payload.cards]
      state.usersGroupByDepartments.total = payload.total
    })
    builder.addCase(fetchUsersCardsGroupedByDeptPaginated.rejected, (state, { meta }) => {
      // Only clear on first-page failures to avoid wiping already-loaded pages
      if (!meta.arg.page || meta.arg.page <= 1) {
        state.usersGroupByDepartments = initialState.usersGroupByDepartments
      }
    })
    builder.addCase(fetchUsersList.pending, (state) => {
      state.users.list = []
      state.users.total = 0
    })
    builder.addCase(fetchUsersList.fulfilled, (state, { payload }) => {
      state.users.list = payload.list
      state.users.total = payload.total
      state.userEntity.summary = {
        groupsCount: payload?.groupsCount || 0,
        usersCount: payload?.usersCount || 0
      }
    })
    builder.addCase(fetchAccessControlFilters.fulfilled, (state, { payload }) => {
      state.filters.entityTypes = payload.entityTypes
      state.filters.datasources = payload.datasources
      state.filters.departments = payload?.departments || []
      state.filters.attributes = payload.attributes
    })
    builder.addCase(fetchAccessControlFilters.rejected, (state) => {
      state.filters = initialState.filters
    })
    builder.addCase(fetchAccessControlDepartments.fulfilled, (state, { payload }) => {
      state.filters.departments = payload?.departments || []
    })
    builder.addCase(fetchAccessControlDepartments.rejected, (state) => {
      state.filters.departments = initialState.filters.departments
    })
    builder.addCase(fetchUsersList.rejected, (state) => {
      state.users.list = []
      state.users.total = 0
    })
    builder.addCase(fetchUsersSummary.rejected, (state) => {
      state.usersSummary = initialState.usersSummary
    })
    builder.addCase(fetchUsersSummary.fulfilled, (state, { payload }) => {
      state.usersSummary = payload
    })
    builder.addCase(fetchUserOverview.rejected, (state) => {
      state.userOverview = initialState.userOverview
    })
    builder.addCase(fetchUserOverview.fulfilled, (state, { payload }) => {
      state.userOverview = payload
    })
    builder.addCase(fetchGroupOverview.fulfilled, (state, { payload }) => {
      state.groupOverview = payload
    })
    builder.addCase(fetchGroupOverview.rejected, (state) => {
      state.groupOverview = initialState.groupOverview
    })
    builder.addCase(fetchUserDatasources.rejected, (state) => {
      state.usersDatasources = initialState.usersDatasources
    })
    builder.addCase(fetchUserDatasources.fulfilled, (state, { payload }) => {
      state.usersDatasources = payload
    })
    builder.addCase(fetchObjectsSummary.rejected, (state) => {
      state.objects.openAccess = initialState.objects.openAccess
      state.objects.excessiveAccess = initialState.objects.excessiveAccess
    })
    builder.addCase(fetchObjectsSummary.fulfilled, (state, { payload }) => {
      state.objects.openAccess = payload.openAccess
      state.objects.excessiveAccess = payload.excessiveAccess
    })
    builder.addCase(fetchObjectsCounts.fulfilled, (state, { payload }) => {
      state.objects.objectsFilteredCount = payload.objectsCount
      state.objects.ownersFilteredCount = payload.ownersCount
    })
    builder.addCase(fetchObjectsCounts.rejected, (state) => {
      state.objects.objectsFilteredCount = initialState.objects.objectsFilteredCount
      state.objects.ownersFilteredCount = initialState.objects.ownersFilteredCount
    })
    builder.addCase(fetchAccessControlGlobalObjectsSummary.fulfilled, (state, { payload }) => {
      state.objects.openAccess = payload.openAccess
      state.objects.excessiveAccess = payload.excessiveAccess
    })
    builder.addCase(fetchAccessControlGlobalObjectsSummary.rejected, (state) => {
      state.objects.openAccess = initialState.objects.openAccess
      state.objects.excessiveAccess = initialState.objects.excessiveAccess
    })
    builder.addCase(fetchGlobalObjectsCards.fulfilled, (state, { payload }) => {
      state.objects.globalCards = payload.cards
      state.objects.globalCardsTotal = payload.total
    })
    builder.addCase(fetchGlobalObjectsCards.rejected, (state) => {
      state.objects.globalCards = initialState.objects.globalCards
      state.objects.globalCardsTotal = initialState.objects.globalCardsTotal
    })
    builder.addCase(fetchObjectsCards.fulfilled, (state, { payload }) => {
      state.objects.cards = payload.cards
      state.objects.cardsTotal = payload.total
    })
    builder.addCase(fetchObjectsCards.rejected, (state) => {
      state.objects.cards = initialState.objects.cards
      state.objects.cardsTotal = initialState.objects.cardsTotal
    })
    builder.addCase(fetchObjectsCardsBySensitivity.fulfilled, (state, { payload }) => {
      state.objects.cardsBySensitivity = payload
    })
    builder.addCase(fetchObjectsCardsBySensitivity.rejected, (state) => {
      state.objects.cardsBySensitivity = initialState.objects.cardsBySensitivity
    })
    builder.addCase(fetchTotalObjectsForUserOrGroup.fulfilled, (state, { payload }) => {
      state.objects.userOrGroupsTotalObjects = payload
    })
    builder.addCase(fetchTotalObjectsForUserOrGroup.rejected, (state) => {
      state.objects.userOrGroupsTotalObjects = initialState.objects.userOrGroupsTotalObjects
    })
    builder.addCase(fetchObjectsAccessViaGroup.fulfilled, (state, { payload }) => {
      state.objects.accessViaGroup = payload
    })
    builder.addCase(fetchObjectsAccessViaGroup.rejected, (state) => {
      state.objects.accessViaGroup = initialState.objects.accessViaGroup
    })
    builder.addCase(fetchObjectsList.rejected, (state) => {
      state.objects.list = initialState.objects.list
      state.objects.listTotal = initialState.objects.listTotal
      state.objects.pageInfo = initialState.objects.pageInfo
    })
    builder.addCase(fetchObjectsList.fulfilled, (state, { payload }) => {
      state.objects.list = payload.list
      state.objects.listTotal = payload.total
      state.objects.pageInfo = payload.pageInfo
    })
    builder.addCase(fetchObjectsDetails.fulfilled, (state, { payload }) => {
      if (state.objects?.list?.length) {
        state.objects.list = [...state.objects.list].map((obj) => {
          return obj.id === payload.id ? { ...obj, ...payload } : obj
        })
      }
    })
    builder.addCase(fetchUserEntityCards.rejected, (state) => {
      state.usersEntities = initialState.usersEntities
    })
    builder.addCase(fetchUserEntityCards.fulfilled, (state, { payload }) => {
      state.usersEntities.cards = payload.cards
      state.usersEntities.cardsTotal = payload.totalCards
      state.usersEntities.entitiesAtRisk = payload.entitiesAtRisk
      state.usersEntities.entityTypes = payload.entityTypes
    })
    builder.addCase(fetchUserEntities.fulfilled, (state, { payload }) => {
      state.usersEntities.list = payload.list
      state.usersEntities.total = payload.total
    })
    builder.addCase(fetchUserEntities.rejected, (state) => {
      state.usersEntities.list = initialState.usersEntities.list
      state.usersEntities.total = initialState.usersEntities.total
    })
    builder.addCase(fetchEntitiesViaGroup.fulfilled, (state, { payload }) => {
      state.usersEntities.accessViaGroup = payload
    })
    builder.addCase(fetchEntitiesViaGroup.rejected, (state) => {
      state.usersEntities.accessViaGroup = initialState.usersEntities.accessViaGroup
    })
    builder.addCase(fetchUserAttributesSummary.fulfilled, (state, { payload }) => {
      state.usersAttributes.widgets = payload
    })
    builder.addCase(fetchUserAttributesSummary.rejected, (state) => {
      state.usersAttributes.widgets = initialState.usersAttributes.widgets
    })
    builder.addCase(fetchUserAttributeCards.fulfilled, (state, { payload }) => {
      state.usersAttributes.cards = payload.cards
      state.usersAttributes.cardsTotal = payload.total
    })
    builder.addCase(fetchUserAttributeCards.rejected, (state) => {
      state.usersAttributes.cards = initialState.usersAttributes.cards
      state.usersAttributes.cardsTotal = initialState.usersAttributes.cardsTotal
    })
    builder.addCase(fetchAttributesViaGroup.fulfilled, (state, { payload }) => {
      state.usersAttributes.accessViaGroup = payload
    })
    builder.addCase(fetchAttributesViaGroup.rejected, (state) => {
      state.usersAttributes.accessViaGroup = initialState.usersAttributes.accessViaGroup
    })
    builder.addCase(fetchObjectsWithOpenAccess.rejected, (state) => {
      state.dashboardWidgets.objectsWithOpenAccess =
        initialState.dashboardWidgets.objectsWithOpenAccess
    })
    builder.addCase(fetchObjectsWithOpenAccess.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.objectsWithOpenAccess = payload
    })
    builder.addCase(fetchStaleFilesWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.staleFilesWidget = payload
    })
    builder.addCase(fetchStaleFilesWidget.rejected, (state) => {
      state.dashboardWidgets.staleFilesWidget = initialState.dashboardWidgets.staleFilesWidget
    })
    builder.addCase(fetchObjectsWithExcessiveAccess.rejected, (state) => {
      state.dashboardWidgets.objectsWithExcessiveAccess =
        initialState.dashboardWidgets.objectsWithExcessiveAccess
    })
    builder.addCase(fetchObjectsWithExcessiveAccess.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.objectsWithExcessiveAccess = payload
    })
    builder.addCase(fetchObjectsWithOpenAccessByDept.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.objectsWithOpenAccessByDept = payload
    })
    builder.addCase(fetchObjectsWithOpenAccessByDept.rejected, (state) => {
      state.dashboardWidgets.objectsWithOpenAccessByDept =
        initialState.dashboardWidgets.objectsWithOpenAccessByDept
    })
    builder.addCase(fetchObjectsWithExcessiveAccessByDept.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.objectsWithExcessiveAccessByDept = payload
    })
    builder.addCase(fetchObjectsWithExcessiveAccessByDept.rejected, (state) => {
      state.dashboardWidgets.objectsWithExcessiveAccessByDept =
        initialState.dashboardWidgets.objectsWithExcessiveAccessByDept
    })
    builder.addCase(fetchObjectsWithExternalAccessByDept.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.objectsWithExternalAccessByDept = payload
    })
    builder.addCase(fetchObjectsWithExternalAccessByDept.rejected, (state) => {
      state.dashboardWidgets.objectsWithExternalAccessByDept =
        initialState.dashboardWidgets.objectsWithExternalAccessByDept
    })
    builder.addCase(fetchUsersWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.users = payload
    })
    builder.addCase(fetchUsersWidget.rejected, (state) => {
      state.dashboardWidgets.users = initialState.dashboardWidgets.users
    })
    builder.addCase(fetchGroupsWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.groups = payload
    })
    builder.addCase(fetchGroupsWidget.rejected, (state) => {
      state.dashboardWidgets.groups = initialState.dashboardWidgets.groups
    })
    builder.addCase(fetchIdpWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.idp = payload
    })
    builder.addCase(fetchIdpWidget.rejected, (state) => {
      state.dashboardWidgets.idp = initialState.dashboardWidgets.idp
    })
    builder.addCase(fetchAccess360Widget.fulfilled, (state, { payload, meta }) => {
      const widgetIndex = meta.arg[UNIQUE_WIDGET_INDEX]
      if (widgetIndex) {
        state.dashboardWidgets.access360 = {
          ...state.dashboardWidgets.access360,
          [widgetIndex]: payload
        }
      }
    })
    builder.addCase(fetchAccess360Widget.rejected, (state, { meta }) => {
      const widgetIndex = meta.arg[UNIQUE_WIDGET_INDEX]
      if (widgetIndex && state.dashboardWidgets.access360) {
        delete state.dashboardWidgets.access360[widgetIndex]
      }
    })
    builder.addCase(fetchEntityTypesAccessWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.entityTypesWithAccess = payload
    })
    builder.addCase(fetchEntityTypesAccessWidget.rejected, (state) => {
      state.dashboardWidgets.entityTypesWithAccess =
        initialState.dashboardWidgets.entityTypesWithAccess
    })
    builder.addCase(fetchEntitiesWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.entitiesWithAccess = payload
    })
    builder.addCase(fetchEntitiesWidget.rejected, (state) => {
      state.dashboardWidgets.entitiesWithAccess = initialState.dashboardWidgets.entitiesWithAccess
    })

    builder.addCase(fetchAccessibleWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.accessible = payload
    })
    builder.addCase(fetchAccessibleWidget.rejected, (state) => {
      state.dashboardWidgets.accessible = initialState.dashboardWidgets.accessible
    })
    builder.addCase(fetchAlertsOverviewWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.alertsOverview = payload
    })
    builder.addCase(fetchAlertsOverviewWidget.rejected, (state) => {
      state.dashboardWidgets.alertsOverview = initialState.dashboardWidgets.alertsOverview
    })
    builder.addCase(fetchActivityLogs.rejected, (state) => {
      state.activityLog.list = initialState.activityLog.list
    })
    builder.addCase(fetchActivityLogs.fulfilled, (state, { payload }) => {
      state.activityLog.list = payload.list
    })
    builder.addCase(fetchActivityLogsCount.rejected, (state) => {
      state.activityLog.total = initialState.activityLog.total
    })
    builder.addCase(fetchActivityLogsCount.fulfilled, (state, { payload }) => {
      state.activityLog.total = payload.total
    })
    builder.addCase(fetchRecentAccess.rejected, (state) => {
      state.recentAccess.list = initialState.recentAccess.list
    })
    builder.addCase(fetchRecentAccess.fulfilled, (state, { payload }) => {
      state.recentAccess.list = payload.list
    })
    builder.addCase(fetchRecentAccessCount.fulfilled, (state, { payload }) => {
      state.recentAccess.total = payload.total
    })
    builder.addCase(fetchRecentAccessCount.rejected, (state) => {
      state.recentAccess.total = initialState.recentAccess.total
    })
    builder.addCase(fetchStaleFilesAlertId.fulfilled, (state, { payload }) => {
      state.staleFilesAlertId = payload
    })
    builder.addCase(fetchStaleFilesList.rejected, (state) => {
      state.staleFiles.list = initialState.staleFiles.list
    })
    builder.addCase(fetchStaleFilesList.fulfilled, (state, action) => {
      state.staleFiles.list = action.payload.list
    })
    builder.addCase(fetchStaleFilesCount.fulfilled, (state, action) => {
      state.staleFiles.total = action.payload.total
    })

    builder.addCase(fetchGroupsList.fulfilled, (state, { payload }) => {
      state.groups.list = payload.list
      state.groups.totalList = payload.total
      state.groups.totalGroups = payload.groupsCount
      state.groups.highSensitiveCount = payload.highSensitiveCount
    })
    builder.addCase(fetchGroupsList.rejected, (state) => {
      state.groups.list = []
      state.groups.totalList = 0
      state.groups.totalGroups = 0
      state.groups.highSensitiveCount = 0
    })
    builder.addCase(fetchUsersByGroup.fulfilled, (state, { payload }) => {
      state.groupsUsers.list = payload.usersList
      state.groupsUsers.total = payload.totalUsers
      state.groupsUsers.totalContractorsCount = payload.totalContractorsCount
      state.groupsUsers.totalEmployeesCount = payload.totalEmployeesCount
    })
    builder.addCase(fetchUsersByGroup.rejected, (state) => {
      state.groupsUsers.list = []
      state.groupsUsers.total = 0
      state.groupsUsers.totalContractorsCount = 0
      state.groupsUsers.totalEmployeesCount = 0
    })
    builder.addCase(fetchGroupsByUser.fulfilled, (state, { payload }) => {
      state.usersGroups.list = payload.groups
      state.usersGroups.total = payload.totalGroups
    })
    builder.addCase(fetchGroupsByUser.rejected, (state) => {
      state.usersGroups.list = []
      state.usersGroups.total = 0
    })
    builder.addCase(fetchSubGroups.fulfilled, (state, { payload }) => {
      state.subGroups.list = payload.list
      state.subGroups.total = payload.total
    })
    builder.addCase(fetchSubGroups.rejected, (state) => {
      state.subGroups.list = []
      state.subGroups.total = 0
    })
    builder.addCase(fetchAccessControlIdpDatasources.fulfilled, (state, { payload }) => {
      state.identityProviders.datasources = payload
    })
    builder.addCase(fetchAccessControlIdpDatasources.rejected, (state) => {
      state.identityProviders.datasources = initialState.identityProviders.datasources
    })
    builder.addCase(fetchAccessControlIdpList.fulfilled, (state, { payload }) => {
      state.identityProviders.list = payload.list
      state.identityProviders.total = payload.total
    })
    builder.addCase(fetchAccessControlIdpList.rejected, (state) => {
      state.identityProviders.list = initialState.identityProviders.list
      state.identityProviders.total = initialState.identityProviders.total
    })
    builder.addCase(fetchAccessControlIdpById.rejected, (state) => {
      state.identityProviders.selectedIdp = initialState.identityProviders.selectedIdp
    })
    builder.addCase(fetchAccessControlIdpById.fulfilled, (state, { payload }) => {
      state.identityProviders.selectedIdp = payload
    })
    builder.addCase(fetchAccessControlIdpsByIds.fulfilled, (state, { payload }) => {
      state.identityProviders.selectedIdps = payload
    })
    builder.addCase(fetchAccessControlIdpsByIds.rejected, (state) => {
      state.identityProviders.selectedIdps = initialState.identityProviders.selectedIdps
    })
    builder.addCase(testIdpConnection.fulfilled, (state, { payload }) => {
      state.identityProviders.connectionVerified = payload.success
    })
    builder.addCase(testIdpConnection.rejected, (state) => {
      state.identityProviders.connectionVerified = false
    })
    builder.addCase(fetchReport.fulfilled, (state, { payload }) => {
      state.filesToExport = payload
    })
    builder.addCase(fetchReport.rejected, (state) => {
      state.filesToExport = undefined
    })
    builder.addCase(fetchAccessControlActivityLog.fulfilled, (state, { payload }) => {
      state.activityLogs = payload.list
      state.totalActivityLogs = payload.total
    })
    builder.addCase(fetchAccessControlActivityLog.rejected, (state) => {
      state.activityLogs = []
      state.totalActivityLogs = 0
    })
    builder.addCase(fetchAccessControlActivityLogUsers.fulfilled, (state, { payload }) => {
      state.activityLogUsers = payload
    })
    builder.addCase(fetchAccessControlActivityLogUsers.rejected, (state) => {
      state.activityLogUsers = []
    })
    builder.addCase(fetchUserActivityWidget.fulfilled, (state, { payload }) => {
      state.userActivityWidgetData = payload.list
    })
    builder.addCase(fetchUserActivityWidget.rejected, (state) => {
      state.userActivityWidgetData = []
    })
    builder.addCase(fetchDeletedFiles.fulfilled, (state, { payload }) => {
      state.deletedFiles = payload.list
    })
    builder.addCase(fetchDeletedFiles.rejected, (state) => {
      state.deletedFiles = []
    })
    builder.addCase(fetchOpenAccessSummaryWidget.fulfilled, (state, { payload }) => {
      state.dashboardWidgets.openAccessSummaryWidget = payload
    })
    builder.addCase(fetchOpenAccessSummaryWidget.rejected, (state) => {
      state.dashboardWidgets.openAccessSummaryWidget =
        initialState.dashboardWidgets.openAccessSummaryWidget
    })
    builder.addCase(fetchAccessControlAllObjectsCount.fulfilled, (state, { payload }) => {
      state.objectsCount = payload
    })
    builder.addCase(fetchAccessControlAllObjectsCount.rejected, (state) => {
      state.objectsCount = undefined
    })
    builder.addCase(fetchAccessibleAttributesWidget.fulfilled, (state, { payload }) => {
      state.accessibleAttributesWidgetData = payload
    })
    builder.addCase(fetchAccessibleAttributesWidget.rejected, (state) => {
      state.accessibleAttributesWidgetData = []
    })
    builder.addCase(fetchUsersDatasourcesWidget.fulfilled, (state, { payload }) => {
      state.usersDatasourcesWidgetData = payload
    })
    builder.addCase(fetchUsersDatasourcesWidget.rejected, (state) => {
      state.usersDatasourcesWidgetData = []
    })
    builder.addCase(fetchAllAcesssControlUsers.fulfilled, (state, { payload }) => {
      state.allUsers = payload
    })
    builder.addCase(fetchAllAcesssControlUsers.rejected, (state) => {
      state.allUsers = []
    })
    // Salesforce dashboard widgets
    builder.addCase(fetchSalesforceMonitoredUsers.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.monitoredUsers = payload
    })
    builder.addCase(fetchSalesforceMonitoredUsers.rejected, (state) => {
      state.salesforceDashboard.monitoredUsers = undefined
    })
    builder.addCase(fetchSalesforceObjects.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.objects = payload
    })
    builder.addCase(fetchSalesforceObjects.rejected, (state) => {
      state.salesforceDashboard.objects = undefined
    })
    builder.addCase(fetchSalesforceUnresolvedAlerts.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.unresolvedAlerts = payload
    })
    builder.addCase(fetchSalesforceUnresolvedAlerts.rejected, (state) => {
      state.salesforceDashboard.unresolvedAlerts = undefined
    })
    builder.addCase(fetchSalesforceUserAccess.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.userAccess = payload
    })
    builder.addCase(fetchSalesforceUserAccess.rejected, (state) => {
      state.salesforceDashboard.userAccess = undefined
    })
    builder.addCase(fetchSalesforceUserCounts.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.userCounts = payload
    })
    builder.addCase(fetchSalesforceUserCounts.rejected, (state) => {
      state.salesforceDashboard.userCounts = undefined
    })
    builder.addCase(fetchSalesforceUserDetails.fulfilled, (state, { payload }) => {
      state.salesforceDashboard.userDetails = payload
    })
    builder.addCase(fetchSalesforceUserDetails.rejected, (state) => {
      state.salesforceDashboard.userDetails = undefined
    })
  }
})

export const {
  resetUsersCardsGroupedByDept,
  resetSelectedIdp,
  resetAttributes,
  resetEntities,
  resetFilesToExport,
  resetAlertsOverview,
  resetTestConnection,
  resetStaleFilesWidget,
  resetStaleFilesAlertId,
  resetUserActivityWidget,
  resetAllObjectsCount,
  resetOpenAccessSummaryWidget
} = accessControlSlice.actions
export default accessControlSlice.reducer
